module.exports = __webpack_public_path__ + "media/images/vp/samples/22-212fe7c075ea65ebba1eb06308664bc2.jpg";